import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router';

/**
 * QA-350: 다른 화면으로 이동하면 맨 위에서 시작한다. 창 스크롤이 이전 화면 위치 그대로 남아, 상품 수정 화면
 * 아래에서 저장 → 목록으로 오면 목록 하단에서 시작했다.
 * - 뒤로/앞으로(POP)는 브라우저 복원에 맡긴다.
 * - 같은 화면에서 쿼리만 바뀌는 경우(탭·필터)는 pathname 이 같아 건드리지 않는다.
 */
export const useScrollTopOnNavigate = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();
  useEffect(() => {
    if (navigationType !== 'POP') window.scrollTo(0, 0);
    // pathname 이 바뀔 때만 실행한다(navigationType 은 그 시점 값).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
};
